<era-user-list-ui [users]="users()"
                  [editEnabled]="editEnabled"
                  (addUserEvent)="addUserEvent()"
                  (toggleEditEvent)="toggleEditEvent()"></era-user-list-ui>